/**
 * Private message form component.
 *
 * @param string uuid
 */
export default function () {
    return {
        isFocused: false,
        content: '',
        submitting: false,
        resize: function () {
            this.$refs.responseArea.style.height = 'auto';
            this.$refs.responseArea.style.height = this.$refs.responseArea.scrollHeight + 'px';
        },
        submit: function () {
            window.livewire.emit('sendMessage', this.content);
            this.submitting = true;
            this.content = '';
            this.$refs.responseArea.style.height = 'auto';

            setTimeout(() => (this.submitting = false), 1500);
        },
        mounted: function () {
            this.$refs.responseArea.focus();
        },
    };
}
